<template>
  <div class="IdBlacklistDia">
    <el-dialog
      :title="'设置黑名单-' + currentRow.merchantName"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="1000px"
      @close="close"
    >
      <p class="red-tip">
        说明：在此处为回收商添加了黑名单门店或黑名单店员，则此门店或店员的订单，不会推送此回收商
      </p>
      <div style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
        <el-button size="mini" icon="el-icon-plus" type="primary" @click="openAddIdDia">新增黑名单ID</el-button>
      </div>
      <div class="el-table-container">
        <el-table
          ref="idBlackTable"
          :data="idBlackTableData"
          v-loading="idBlackTableLoading"
          max-height="500"
          border
        >
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="商户名称" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="row.factoryName"
                placement="top"
              >
                <div class="nowrap-ellipsis">
                  {{ row.factoryName }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="所属外部渠道" align="center" prop="channel" width="120"></el-table-column>
          <el-table-column label="黑名单门店" align="center" width="120">
            <template slot-scope="{ row }">
              <span class="btn" @click="openSeeIdDia(row,'STORE')">{{ row.storeCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="黑名单店员" align="center" width="120">
            <template slot-scope="{ row }">
              <span class="btn" @click="openSeeIdDia(row,'EMPLOYEE')">{{ row.employeeCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="添加人" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.addUser }}</span>
            </template>
          </el-table-column>
          <el-table-column label="添加时间" align="center" prop="createTime"></el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="close">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="'添加黑名单ID-' + currentRow.merchantName"
      :visible.sync="addIdDiaShow"
      :close-on-click-modal="false"
      width="700px"
      @closed="addIdDiaClosed"
    >
      <p class="red-tip mb-10">
        说明：输入ID后点击查询，自动识别出所属商户、ID归属的门店或店员；
      </p>
      <div class="flex mb-10">
        <span class="red-tip">*</span>
        <span>黑名单ID（平台ID）</span>
        <el-radio-group v-model="addType" size="small">
          <el-radio-button label="STORE">门店ID</el-radio-button>
          <el-radio-button label="EMPLOYEE">店员ID</el-radio-button>
        </el-radio-group>
        <el-input
          style="width: 200px;margin: 0 10px;"
          size="small"
          :placeholder="'请输入平台的' + (addType==='STORE'?'门店ID':'店员ID')"
          v-model.trim="platId"
          clearable>
        </el-input>
        <el-button size="small" type="primary" :loading="searchBtnLoading" @click="searchId">查询</el-button>
        <el-button type="text" class="btn" @click="addIdBatch">批量添加</el-button>
      </div>
      <div class="el-table-container">
        <el-table
          ref="idAddTable"
          :data="idAddTableData"
          max-height="500"
          border
        >
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="平台ID" align="center" prop="platId"></el-table-column>
          <el-table-column label="所属商户名称" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="row.merchantName"
                placement="top"
              >
                <div class="nowrap-ellipsis">
                  {{ row.merchantName }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="门店/店员" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.type==='STORE'?'门店':'店员' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="外部ID" align="center" prop="outNo"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row , $index }">
              <span class="btn-red" @click="removeAddItem(row,$index)">移除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addIdDiaShow = false">取消</el-button>
        <el-button type="primary" :disabled="!idAddTableData.length" @click="addIdSubmit"
          >保存并生效</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="seeIdDiaTitle"
      :visible.sync="seeIdDiaShow"
      :close-on-click-modal="false"
      width="700px"
      @closed="seeIdDiaClosed"
    >
      <div class="el-table-container">
        <el-table
          ref="seeIdTable"
          :data="seeIdTableData"
          v-loading="seeIdTableLoading"
          max-height="500"
          border
        >
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="平台ID" align="center" prop="platId"></el-table-column>
          <el-table-column label="所属商户名称" align="center">
            <template slot-scope="{ row }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="row.merchantName"
                placement="top"
              >
                <div class="nowrap-ellipsis">
                  {{ row.merchantName }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="外部ID" align="center" prop="outNo"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="{ row }">
              <span class="btn-red" @click="removeSeeItem(row)">移除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="seeIdDiaShow = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="批量添加黑名单ID"
      :visible.sync="batchDiaShow"
      :close-on-click-modal="false"
      width="600px"
      @closed="batchDiaClosed"
    >
      <p class="red-tip mb-10">
        多个ID之间用中文的“；”隔开，单次最多可添加100个
      </p>
      <el-input
        type="textarea"
        :placeholder="'在此处粘贴（ctrl+v）' + (addType==='STORE'?'门店ID':'店员ID') + '，多个用中文“；”隔开'"
        v-model="batchId"
        :rows="10"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="batchDiaShow = false">取消</el-button>
        <el-button type="primary" :loading="batchBtnLoading" @click="batchSubmit"
          >查询</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="批量查询失败结果"
      :visible.sync="batchErrDiaShow"
      :close-on-click-modal="false"
      width="500px"
    >
      <p class="mb-10">已成功查询<span style="color: #80C269;font-size: 18px;margin: 0 4px;">{{identifiedIds.length}}</span>条ID</p>
      <div class="flex">
        <div style="flex: 1;" v-if="unrecognizedIds">
          <p style="margin-bottom: 5px;">未识别ID</p>
          <el-card shadow="never" :body-style="{padding: '5px 10px',overflow: 'auto',height: '150px'}">
            <span>{{ unrecognizedIds }}</span>
          </el-card>
        </div>
        <span style="margin: 0 10px;" v-if="unrecognizedIds && blackedOutIds"></span>
        <div style="flex: 1;" v-if="blackedOutIds">
          <p style="margin-bottom: 5px;">平台已拉黑ID</p>
          <el-card shadow="never" :body-style="{padding: '5px 10px',overflow: 'auto',height: '150px'}">
            <span>{{ blackedOutIds }}</span>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="batchErrDiaShow = false">重新查询</el-button>
        <el-button type="primary" @click="batchErrKnow" v-if="identifiedIds.length"
          >放入已识别ID</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="安全验证" :visible.sync="commandDisableShow" :close-on-click-modal="false" width="500px"
      @closed="commandClosed">
      <div v-if="tipExplain" style="margin-bottom: 20px;">
        <span style="color: #ff8695;font-size: 14px;">{{ tipExplain }}</span>
      </div>
      <div class="tip-centent">
        <span>{{ commandTipText }}</span>
      </div>
      <div class="command">
        <div style="width: max-content">谷歌验证码：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="commandDisableShow = false">取消</el-button>
        <el-button type="primary" @click.native="commandSureAdd" :loading="commandButLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {    
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      idBlackTableData: [],
      idBlackTableLoading: false,
      // 添加黑名单ID弹窗
      addIdDiaShow: false,
      addType: "STORE",
      platId: "",
      searchBtnLoading: false,
      idAddTableData: [],
      // 批量添加弹窗
      batchDiaShow: false,
      batchBtnLoading: false,
      batchId: "",
      batchErrDiaShow: false,
      identifiedIds: [],
      unrecognizedIds: "",
      blackedOutIds: "",
      // 安全验证
      commandTipText: "",
      tipExplain: "",
      commandType: "",
      commandDisableShow: false,
      command: "",
      commandButLoading: false,
      // 查看门店/店员弹框
      seeIdDiaShow: false,
      seeIdDiaTitle: "",
      seeIdTableLoading: false,
      seeIdTableData: [],
      seeIdRow: {},
      seeIdType: "",
      removeCurrentRow: {}
    };
  },
  created() {
    this.getIdBlackList()
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // 获取黑名单ID列表
    getIdBlackList() {
      this.idBlackTableLoading = true
      _api.merchantIdBlackList({merchantID: this.currentRow.merchantId}).then(res => {
        if(res.code === 1){
          this.idBlackTableData = res.data || []
        }
        this.idBlackTableLoading = false
      })
    },
    // 打开添加黑名单ID弹窗
    openAddIdDia() {
      this.addType = "STORE";
      this.addIdDiaShow = true;
    },
    // 添加黑名单ID弹窗关闭
    addIdDiaClosed() {
      this.platId = ""
      this.idAddTableData = []
    },
    // 查询id按钮
    searchId() {
      if(!this.platId.trim()){
        return this.$message.error("查询ID不能为空")
      }
      let parame = {
        merchantId: this.currentRow.merchantId,
        platId: this.platId,
        type: this.addType
      };
      this.searchBtnLoading = true
      _api.selectByBlackID(parame).then((res) => {
        if(res.code === 1 && res.data){
          const isExist = this.idAddTableData.some(item => (item.platId === res.data.platId && item.type === res.data.type))
          if (isExist) {
            this.$message.warning('该ID已查询添加在下方表格中')
          } else {
            this.idAddTableData.push(res.data)
          }
        }
      }).finally(() => {
        this.searchBtnLoading = false
      });
    },
    // 批量添加按钮
    addIdBatch() {
      this.batchId = "";
      this.blackedOutIds = "";
      this.unrecognizedIds = "";
      this.identifiedIds = []
      this.batchDiaShow = true;
    },
    batchDiaClosed() {
      this.batchId = ""
    },
    // 批量添加确定
    batchSubmit() {
      let platIDs = this.batchId.split('；').filter(id => id.trim() !== '')
      if(!this.batchId.trim() || !platIDs.length){
        return this.$message.error("查询ID不能为空")
      }
      let parame = {
        merchantId: this.currentRow.merchantId,
        blackType: this.addType,
        platIDs
      }
      this.batchBtnLoading = true
      _api.selectByBlackIDBatch(parame).then((res) => {
        if(res.code === 1){
          this.blackedOutIds = res.data.blackedOutIds.join('；');
          this.unrecognizedIds = res.data.unrecognizedIds.join('；');
          this.identifiedIds = res.data.detail
          if(this.blackedOutIds || this.unrecognizedIds){
            this.batchErrDiaShow = true
          }else{
            this.idAddTableData = [...this.idAddTableData, ...res.data.detail].filter((item, index, self) => 
              index === self.findIndex(t => t.platId === item.platId)
            )
            this.batchDiaShow = false
          }
        }
      }).finally(() => {
        this.batchBtnLoading = false
      });
    },
    // 识别失败弹窗确定
    batchErrKnow() {
      this.idAddTableData = this.idAddTableData.concat(this.identifiedIds)
      this.batchErrDiaShow = false
      this.batchDiaShow = false
    },
    // 添加ID时 前端移除
    removeAddItem(row,index) {
      this.idAddTableData = this.idAddTableData.filter((item, i) => i !== index);
    },
    // 添加黑名单ID保存并生效
    addIdSubmit() {
      this.tipExplain = '添加黑名单后，黑名单门店和黑名单店员在生效时间后下的订单将不再推送此回收商，请谨慎操作！'
      this.commandTipText = '是否确认保存并生效？';
      this.commandType = "save";
      this.commandDisableShow = true;
    },
    commandClosed() {
      this.command = ''
    },
    commandSureAdd() {
      if(!this.command.trim()){
        return this.$message.error('请输入动态口令')
      }
      this.commandButLoading = true
      if(this.commandType === "save"){
        let addBlackListDtos = this.idAddTableData.map(item => {
          return {
            platId: item.platId,
            blackType: item.type,
          }
        })
        let params = {
          merchantId: this.currentRow.merchantId,
          command: this.command,
          addBlackListDtos,
        }
        _api.addBlackListBatch(params).then(res => {
          if(res.code === 1){
            this.$message.success(res.msg || "操作成功")
            this.commandDisableShow = false
            this.addIdDiaShow = false
            this.getIdBlackList()
          }
        }).finally(()=>{
          this.commandButLoading = false
        })
      }else if(this.commandType === "remove"){
        let params = {
          command: this.command,
          id: this.removeCurrentRow.id,
        }
        _api.deleteBlackListByID(params).then(res => {
          if(res.code === 1){
            this.$message.success(res.msg || "移除成功")
            this.commandDisableShow = false
            this.getSeeIdList()
            this.getIdBlackList()
          }
        }).finally(()=>{
          this.commandButLoading = false
        })
      }
    },
    openSeeIdDia(row,type) {
      this.seeIdRow = row
      this.seeIdType = type
      this.seeIdDiaTitle = '查看黑名单' + (type==='STORE'?'门店-':'店员-') + this.currentRow.merchantName
      this.seeIdDiaShow = true
      this.getSeeIdList()
    },
    getSeeIdList() {
      let params = {
        merchantId:this.currentRow.merchantId,
        factoryId: this.seeIdRow.factoryId,
        blackType: this.seeIdType
      }
      this.seeIdTableLoading = true
      _api.getIdStoreOrEmployee(params).then(res => {
        if(res.code === 1){
          this.seeIdTableData = res.data || []
        }
      }).finally(()=>{
        this.seeIdTableLoading = false
      })
    },
    seeIdDiaClosed() {
      this.seeIdTableData = []
    },
    removeSeeItem(row) {
      this.removeCurrentRow = row
      this.tipExplain = '移除黑名单后，黑名单门店和黑名单店员在移除时间后下的订单将可以推送此回收商！'
      this.commandTipText = '是否确认移除？';
      this.commandType = "remove";
      this.commandDisableShow = true;
    }
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.IdBlacklistDia {
  .red-tip {
    color: #ff687b;
    font-size: 14px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .flex{
    display: flex;
    align-items: center;
  }
  .nowrap-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
  .btn {
    text-decoration: underline;
    cursor: pointer;
    color: #0981ff;
  }
  .btn-red{
    text-decoration: underline;
    cursor: pointer;
    color: #ff687b;
  }
  .tip-centent {
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
  }

  .command {
    display: flex;
    align-items: center;

    /deep/.el-input {
      width: 300px;
    }
  }
}
</style>
